<template>
  <b-card>
    <b-overlay :show="show" rounded="sm">
      <!-- form -->
      <validation-observer ref="simpleRules">
        <b-form class="mt-2">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Company image"
                  :rules="`size:${$sizeFilesUser}`"
                >
                  <label for="profile-picture"
                    >{{ $t("CompanyForm.main_company_image") }}

                    <i
                      id="CompanyImage-popover"
                      class="fa-solid fa-circle-info"
                    />
                  </label>
                  <b-popover
                    target="CompanyImage-popover"
                    title=""
                    placement="top"
                    triggers="hover focus"
                    :content="$t('companyPopover.CompanyImage')"
                  />
                  <b-form-file
                    v-model="createCompanyProfile.ProfilePicture"
                    required
                    accept="image/jpeg, image/png, image/gif"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('common.Choose_file_drop')"
                    :browse-text="$t('common.Browse')"
                    drop-placeholder="Drop file here..."
                    :multiple="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="Company-Documents"
                  >{{ $t("CompanyForm.company_documents") }}
                  <i
                    id="CompanyDocuments-popover"
                    class="fa-solid fa-circle-info"
                  />
                </label>
                <b-popover
                  target="CompanyDocuments-popover"
                  title=""
                  placement="top"
                  triggers="hover focus"
                  :content="$t('companyPopover.CompanyDocuments')"
                />
                <validation-provider
                  #default="{ errors }"
                  name="Company Documents"
                  :rules="`size:${$sizeFilesUser}`"
                >
                  <b-form-file
                    v-model="createCompanyProfile.CompanyDocuments"
                    accept="application/pdf, application/vnd.ms-excel,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    multiple
                    :placeholder="$t('common.Choose_file_drop')"
                    :browse-text="$t('common.Browse')"
                    drop-placeholder="Drop file here..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="Proof-Business"
                  >{{ $t("CompanyForm.proof_of_business") }}
                  <i
                    id="CompanyProof-popover"
                    class="fa-solid fa-circle-info"
                  />
                </label>
                <b-popover
                  target="CompanyProof-popover"
                  title=""
                  placement="top"
                  triggers="hover focus"
                  :content="$t('companyPopover.CompanyProof')"
                />
                <validation-provider
                  #default="{ errors }"
                  name="Company Proof"
                  :rules="`size:${$sizeFilesUser}`"
                >
                  <b-form-file
                    v-model="createCompanyProfile.ProofBusiness"
                    accept="application/pdf, application/vnd.ms-excel,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    multiple
                    :placeholder="$t('common.Choose_file_drop')"
                    :browse-text="$t('common.Browse')"
                    drop-placeholder="Drop file here..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="company-photos"
                  >{{ $t("CompanyForm.company_images") }}
                  <i
                    id="companyPhotos-popover"
                    class="fa-solid fa-circle-info"
                  />
                </label>
                <b-popover
                  target="companyPhotos-popover"
                  title=""
                  placement="top"
                  triggers="hover focus"
                  :content="$t('companyPopover.companyPhotos')"
                />
                <validation-provider
                  #default="{ errors }"
                  name="Company Photos"
                  :rules="`size:${$sizeFilesUser}`"
                >
                  <b-form-file
                    v-model="createCompanyProfile.CompanyPhotos"
                    accept="image/jpeg, image/png, image/gif"
                    multiple
                    :placeholder="$t('common.Choose_file_drop')"
                    :browse-text="$t('common.Browse')"
                    drop-placeholder="Drop file here..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mr-1"
                @click.prevent="validationForm"
              >
                {{ $t("dashboard.SaveChanges") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <hr />
      <br />
      <b-col cols="12">
        <b-table
          striped
          hover
          :items="companyProfile.company.files"
          :fields="$store.state.locale.locale == 'ar' ? fieldsArabic : fields"
        >
          <template #cell(assets)="data">
            <div v-viewer class="images">
              <b-avatar
                v-if="data.item.type.includes('image')"
                variant="primary"
                :src="data.item.fileUrl"
                text="BV"
              />
            </div>
            <a
              v-if="data.item.type.includes('application')"
              :href="data.item.fileUrl"
              target="_blank"
              >{{ $t("dashboard.Preview") }}</a
            >
          </template>
          <template #cell(actions)="data">
            <b-button
              small
              variant="danger"
              @click="deleteFileById(data.item._id)"
            >
              {{ $t("dashboard.Delete") }}
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-overlay>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";

import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
  BFormInvalidFeedback,
  BTable,
  BAvatar,
  BPopover,
  BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    ToastificationContent,
    BFormInvalidFeedback,
    BTable,
    BAvatar,
    BPopover,
    VueViewer,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  //   props: {
  //     generalData: {
  //       type: Object,
  //       default: () => {},
  //     },
  //   },
  props: {
    companyProfile: {},
  },
  data() {
    return {
      show: false,
      boxTwo: "",
      fields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "assets",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
        },
      ],
      fieldsArabic: [
        {
          label: "اسم الملف",
          key: "name",
          sortable: true,
        },
        {
          label: "الملف",
          key: "assets",
          sortable: false,
        },
        {
          label: "الإجراء",
          key: "actions",
          sortable: false,
        },
      ],
      //   optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      profileFile: null,

      errorMessage: "",
      isValidNumber: null,
      sendPhoneNumber: null,
      phoneNumber: "",
      phoneCode: "SY",
      selectedIndustry: [],
      createCompanyProfile: {
        ProfilePicture: null,
        CompanyDocuments: [],
        ProofBusiness: [],
        CompanyPhotos: [],
      },
      companyPopover: {
        EBITDA:
          "Investors/Buyers evaluate your business proposal based on this information. It is best to communicate this information upfront instead of wasting your time and theirs.",
        MonthlySales:
          "Investors/Buyers evaluate your business proposal based on this information. It is best to communicate this information upfront instead of wasting your time and theirs.",
        AnnualSales:
          "Investors/Buyers evaluate your business proposal based on this information. It is best to communicate this information upfront instead of wasting your time and theirs.",
        CompanyImage:
          "Kindly upload your facility / office pictures as profiles with photos get higher rating and visibility. You can upload jpg, bmp, png, tiff, gif files which are less than 3MB in size.",
        CompanyDocuments:
          "Profiles with documents get higher rating and visibility. Documents uploaded are accessible only to members introduced to you. You can upload word, excel, powerpoint, pdf, jpg, bmp, png, gif, mp4 files which are less than 3MB in size.",
        CompanyProof:
          "You can attach documents such as tax certificate, incorporation certificate, govt registration certificate or evidence of revenue such as bank statement, screenshot of sales, etc. Uploading this document will help our review team to verify and approve your profile faster. You can upload word, excel, powerpoint, pdf, jpg, bmp, png, gif files which are less than 3MB in size.",
        companyPhotos:
          "You can attach documents such as tax certificate, incorporation certificate, govt registration certificate or evidence of revenue such as bank statement, screenshot of sales, etc. Uploading this document will help our review team to verify and approve your profile faster. You can upload word, excel, powerpoint, pdf, jpg, bmp, png, gif files which are less than 3MB in size.",
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },

  methods: {
    ...mapActions({
      editCompany: "profile/editCompany",
      deleteUserFile: "profile/deleteUserFile",
    }),
    deleteFileById(id) {
      //   deleteData.append("profileId", this.serviceProfile._id);
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(this.$t("messages.Please_confirm_delete"), {
          title: this.$t("messages.Please_Confirm"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("messages.YES"),
          cancelTitle: this.$t("messages.NO"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            const deleteData = new FormData();
            deleteData.append("fileId", id);
            this.deleteUserFile(deleteData)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: this.$t("messages.Deleted_successfully"),
                    icon: "CoffeeIcon",
                    variant: "success",
                  },
                });
                this.companyProfile.company.files =
                  this.companyProfile.company.files.filter(
                    (data) => data._id != id
                  );
              })
              .catch((error) => {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: error.response.data.error.message,
                    icon: "CoffeeIcon",
                    variant: "error",
                  },
                });
                // this.$router.push({ name: "idea-listAll" });
              });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.simpleRules.validate().then((success) => {
          if (success) {
            this.show = true;
            const userData = new FormData();
            // eslint-disable-next-line no-underscore-dangle
            userData.append("userId", this.user._id);
            userData.append("userType", "company");
            if (this.createCompanyProfile.ProfilePicture) {
              userData.append(
                "companyImage",
                this.createCompanyProfile.ProfilePicture
              );
            }
            if (this.createCompanyProfile.CompanyDocuments) {
              for (const i of Object.keys(
                this.createCompanyProfile.CompanyDocuments
              )) {
                userData.append(
                  "companyDocuments",
                  this.createCompanyProfile.CompanyDocuments[i]
                );
              }
            }
            if (this.createCompanyProfile.ProofBusiness) {
              for (const i of Object.keys(
                this.createCompanyProfile.ProofBusiness
              )) {
                userData.append(
                  "companyBusinessProof",
                  this.createCompanyProfile.ProofBusiness[i]
                );
              }
            }
            if (this.createCompanyProfile.CompanyPhotos) {
              for (const i of Object.keys(
                this.createCompanyProfile.CompanyPhotos
              )) {
                userData.append(
                  "companyProductPhotos",
                  this.createCompanyProfile.CompanyPhotos[i]
                );
              }
            }

            this.editCompany(userData)
              .then((response) => {
                // console.log(response.data.message);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t("messages.Added_successfully"),
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
                this.show = false;
              })
              .catch((error) => {
                this.show = false;
                this.errorMessage = error.response.data.error.message;
              });
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    // resetForm() {
    //   this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    // },
  },
};
</script>
